module.exports = __webpack_public_path__ + "static/media/pin4.004f9c28.png";